// reward token id on coingecko ( get this ids on the info tab on coingecko)
export const ids = [
  "wbnb", //WBNB , BNB
  "usd-coin", //USDC , BNB
  "pancakeswap-token", // CAKE
  "justus", // justus bnb
  "PTC",
];
